/**
 * Disable Flags Module
 * Allows flags to be used in the URL to indicate disabling certain position
 * version 2.0.0
 *
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 *
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/disableflags',['jquery', 'logging', 'storage', 'utilities'], function($, logging, storage, utilities) {
    'use strict';

    var _ModuleName = 'DFP Disable Flag Module';
    var _config = {};
    var _data = {
        records: [],
        disabledPositions: []
    };

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function(config) {
        $.extend(_config, config.disableflags);

        // build list of disabled positions
        for(var i = 0; i < _config.flags.length; i++) {
            var flag = _config.flags[i];
            var result = utilities.getParameter(document.URL, flag.key);
            if(result) {
                _data.disabledPositions.push(flag.position);
            }
        }
    };

    /**
     * Start rate limit module
     */
    var start = function() {
        _printFlagDisabledResults();
    };

    /**
     * Checks if a given ad slot can serve to the current user.
     * @param {AdSlot} slot Ad slot object
     */
    var canServe = function(slot) {
        // If limits are disabled, return true
        if (typeof _config.enabled == 'undefined' || _config.enabled === false) return true;

        // Otherwise, calculate whether to display
        var sname = _getUniqueName(slot);

        // First check storage to see if it was previously calculated
        if (_config.storage.enabled) {
            var storedDisabled = storage.getSessionStorage(sname);
            if (typeof storedDisabled == 'boolean' && storedDisabled) {
                ;

                // Record the Flag Disabled Slot Result
                _recordFlagDisabledSlot(slot);

                // Since disabled, we can not serve the slot
                return false;
            }
        }

        // If not, calculate
        var disabled = _data.disabledPositions.includes(slot.position);

        // Store result
        if (disabled && _config.storage.enabled) {
            storage.setSessionStorage(sname, true);
        }

        // Record the Flag Disabled Slot Result
        if(disabled) {
            _recordFlagDisabledSlot(slot);
        }

        // return whether we can display the slot
        return !disabled;
    };

    /**
     * Disables this module
     */
    var disableStorage = function() {
        _config.storage.enabled = false;
    };

    /**
     * Checks if a slot was served
     * @param {String} position position value of the slot you're checking on
     */
    var wasServed = function(position) {
        // Check if the position has a rate limit record
        var record = _data.records.find(function(r) {
            return (r.position = position);
        });
        // If nothing was recorded, then we don't know if it was served so return true
        if (typeof record == 'undefined') return true;
        // Return the display record for the position
        return record.display;
    };

    /**
     * Gets a unique storage name specific to this ad slot
     * @param {AdSlot} slot Ad slot object
     */
    var _getUniqueName = function(slot) {
        return _config.storage.flags + slot.position.toLowerCase().replace('_', '-');
    };

    var _recordFlagDisabledSlot = function(slot) {
        var record = _data.records.find(function(r) {
            return (r.position = slot.position);
        });
        if (typeof record == 'undefined') {
            _data.records.push({
                position: slot.position,
                disabled: true
            });
        } else {
            record.disabled = true;
        }
    };

    var _printFlagDisabledResults = function() {
        console.log('Flag Disabled Results: %o', _data.records);
    };

    return {
        init: init,
        start: start,
        canServe: canServe,
        wasServed: wasServed,
        disableStorage: disableStorage,
        enabled: function() {
            return _config.enabled;
        }
    };
});

